const AUTH_PREFIX = '/auth';

export const AuthAPI = {
  login: () => `${AUTH_PREFIX}/token`,
  register: () => `${AUTH_PREFIX}/register`,
  currentUser: () => `${AUTH_PREFIX}/me`,
  refresh: () => `${AUTH_PREFIX}/refresh`,
  logout: () => `${AUTH_PREFIX}/logout`,
  activate: (token: string) => `${AUTH_PREFIX}/activate/${token}`,
  completeActivation: () => `${AUTH_PREFIX}/complete-activation`,
  meContext: () => `${AUTH_PREFIX}/me/context`,

  pushPublicKey: () => `${AUTH_PREFIX}/push/public-key`,
  pushSubscriptions: () => `${AUTH_PREFIX}/push/subscriptions`,
};
